export const blockIconsEditorInsertEmoticon = (
	<span className='material-symbols-outlined'>insert_emoticon</span>
);
